var ResellerService = /** @class */ (function () {
    function ResellerService(api) {
        var _this = this;
        this.getResellersList = function () { return _this.API.get("/resellers"); };
        this.getNormalOrgList = function () {
            return _this.API.get("/organizations?type=normal&pay_method=invoice");
        };
        this.addReseller = function (org_id, reseller_number) {
            return _this.API.put("/organizations/".concat(org_id, "/reseller"), { reseller_number: reseller_number });
        };
        this.editReseller = function (org_id, reseller_number) {
            return _this.API.patch("/resellers/".concat(org_id), { reseller_number: reseller_number });
        };
        this.removeReseller = function (org_id) {
            return _this.API.put("/organizations/".concat(org_id, "/reseller/detach"));
        };
        this.getManagedOrgsListByResellerId = function (org_id) {
            return _this.API.get("/resellers/".concat(org_id, "/managed"));
        };
        this.addManagedOrg = function (reseller_org_id, managed_org_id) {
            return _this.API.put("/organizations/".concat(managed_org_id, "/managed"), {
                id: reseller_org_id,
            });
        };
        this.removeManagedOrg = function (reseller_org_id, managed_org_id) {
            return _this.API.put("/organizations/".concat(managed_org_id, "/managed/detach"), {
                id: reseller_org_id,
            });
        };
        this.getResellerDetailsByResellerId = function (org_id) {
            return _this.API.get("/resellers/".concat(org_id));
        };
        this.getInvoiceSummeryByResellerId = function (org_id) {
            return _this.API.get("/resellers/".concat(org_id, "/invoice/summary"));
        };
        this.downloadReport = function (org_id) {
            return _this.API.getFile("/organizations/".concat(org_id, "/invoice/export"));
        };
        this.generateReportService = function (org_id, emailId, month, year) {
            return _this.API.post("/resellers/".concat(org_id, "/monthly_reports"), {
                email: emailId,
                month: month,
                year: year,
            });
        };
        this.addBundlesToDevPlanManagedOrg = function (reseller_org_id, managed_org_id, bundles) {
            var url = "/resellers/".concat(reseller_org_id, "/managed/").concat(managed_org_id, "/bundle/remove");
            return _this.API.post(url, bundles);
        };
        this.removeBundlesFromDevPlanManagedOrg = function (reseller_org_id, managed_org_id, bundles) {
            var url = "/resellers/".concat(reseller_org_id, "/managed/").concat(managed_org_id, "/bundle/purchase");
            return _this.API.post(url, bundles);
        };
        this.API = api;
    }
    ResellerService.prototype.getProratedAmountForAddons = function (reseller_org_id, managed_org_id, bundles) {
        var url = "/resellers/".concat(reseller_org_id, "/managed/").concat(managed_org_id, "/topups/proration");
        var body = bundles;
        return this.API.patch(url, body);
    };
    return ResellerService;
}());
export { ResellerService };
